import { StickyBottomActions } from "../../design-v2";

// Tier-3 builder presentation seam (Phase 4, mechanical extraction).
//
// The fixed bottom publish bar shared by ManualBuilder and ManualBuilderMulti.
// Presentation only: the containers keep every publish barrier, the disabled
// computation, the error state and the click handler. This component just
// positions them.
export default function PublishBar({ children }) {
  return (
    <StickyBottomActions className="lz-builder-publish-bar">
      {children}
    </StickyBottomActions>
  );
}

export function PublishBarButton({ disabled = false, onClick, children }) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className="lz-builder-publish-bar__button"
    >
      {children}
    </button>
  );
}
